const login = {
    login: '登錄',
    phone: '手機',
    email: '郵箱',
    erCode: '二維碼',
    phoneNo: '手機號',
    sryx: '請輸入郵箱',
    password: '密碼',
    wjmm: '忘記密碼？',
    srmm: '請輸入密碼',
    myzh: '還沒有賬號？',
    ljzc: '立即註冊',
    cxsm: '刷新後使用biking App 重新掃碼',
    xydl: '請在手機上響應登錄',
    smewm: '在Biking App 點擊個人資料圖標，然後按右上角的圖標掃描二維碼',
    qtfs: '其他方式登入',
    ggsfyz: '谷歌身份驗證',
    bdsj: '你已綁定手機',
    bdyx: '你已綁定郵箱',
    fsyzm: '發送驗證碼',
    wcyz: '請完成驗證',
    dlcg: '您已登錄成功，biking歡迎您！',
    bktb: '出於安全考慮，賬戶安全設置修改後的24小時內不可提幣',
    fhdl: '返回登錄頁面',
    jx: '繼續',
    cxfs: '重新發送',
    gxmm: '更新密碼',
    srsjh: '請輸入手機號',
    wjmm1: '忘記密碼',
    sryxdz: '請輸入郵箱地址',
    srzqyx: '請輸入正確的郵箱地址',
    sryzm: '輸入驗證碼',
    czmm: '重置密碼',
    sbdyzm: '收不到驗證碼？',
    srxmm: '請輸入新密碼',
    zczh: '註冊Biking賬號',
    yqm: '邀請碼（選填）',
    sryqm: '請輸入邀請碼',
    zc: '註冊',
    yyzh: '已有賬號？',
    ljdl: '立即登錄',
    fsz: '驗證碼已發送至',
    next: '下一步',
    szmm: '設置密碼',
    submit: '提交',
    zccg: '註冊成功！'
  }
  const download = {
    title: '多元化遊戲及<br/>數字貨幣交易平台',
    subTitle: '幣王可進行多達百種數字貨幣交易',
    xzbw: '為什麼選擇幣王',
    czzz: 'BiKing助您創造、增值及保管財富',
    download: 'App Store 下載',
    downloadtf: 'TestFlight下載',
    cjqxz: '超級簽下載',
    cjq: '超級簽{index}',
    bdxz: '本地下載',
    ggpxz: 'Google Play 下載',
    advantageTitle1: '頂級性能 · 極速交易',
    subTitleSubTitle1: '倫敦證券交易所技術驅動，超低延遲，極速撮合',
    advantageTitle2: '資產保障 · 極致安全',
    subTitleSubTitle2: 'Biking符合CCSS標準，保障資產及數據安全',
    advantageTitle3: '全天候服務',
    subTitleSubTitle3: '保證系統正常運行，提供全天候客戶服務',
    qhidxq: '切換ID詳情介紹',
    step1: '第一步',
    step2: '第二步',
    step3: '第三步',
    step4: '第四步',
    step5: '第五步',
    step6: '第六步',
    step7: '第七步',
    step8: '第八步',
    step9: '第九步',
    step10: '第十步',
    azBiking: '通過App Store安裝BiKing',
    dlxz: '如果您擁有非大陸地區的App ID,請直接登錄App Store下載',
    fdlid: '准备一个非大陆地区App ID',
    yxfshq: '如果您沒有非大陸地區的App ID,可以嘗試通過以下方式獲取',
    qhid: '在App Store切換Apple ID',
    dk: '1.打開',
    ysjtx: 'App Store應用,點擊App Store右上角的頭像',
    cxsrmm: '2.點擊退出登錄,重新輸入Apple ID及密碼',
    wfdl: '* 如果提示“無法登錄”,有可能是您近期切換登錄頻率太高,可以更換ID或者幾個小時之後重試。如果ID被鎖定,則需要進行驗證或更換ID再試',
    azapp: '安装App',
    storesh: '1.登錄成功後,會自動跳轉至D對應地區的 App Store,在App Store中搜索“BiKing”,點擊“Get"按鈕,開始安裝App',
    jxxz: '我有非大陸蘋果ID，繼續下載',
    jxxz1: '繼續下載',
    way1: '方式一',
    wayTitle1: '自己註冊,安全穩定',
    wayBtn1: '查看如何註冊',
    way2: '方式二',
    wayTitle2: '平台參考ID（方便快捷）',
    wayBtn2: '查看參考ID',
    way3: '方式三',
    wayTitle3: '國家地區的引導（自由切換）',
    wayBtn3: '查看如何購買',

    ckzh: '非中國大陸Apple ID 參考賬戶',
    jgck: '以下海外地區ID供參考使用',
    jjfz: '(點擊賬戶或密碼可直接複製)',
    zh: '賬戶',
    mm: '密碼',
    xxxl: '為了防止您的手機信息洩露',
    dlicloud: '請務必不要使用上方的Apple ID登錄ICloud',
    tczh: '使用參考Apple ID 下載過App後,請及時退出該賬號',
    cfsy: '請不要綁定手機號，不然ID將無法重複使用',
    jrql: '掃一掃二維碼加入群聊',
    lxkf: '聯繫客服',

    zjzc: '自己註冊海外ID',
    registerStep1: '第一步 打開appleid首頁',
    registerStep2: '第二步 驗證郵箱',
    registerStep3: '第三步 退出App Store賬號',
    registerStep4: '第四步 在Store登入剛註冊的ID',
    gwzcwz: '在Safari瀏覽器內打開蘋果官網註冊網址：',
    yzdzyx: '填寫完所有的信息點擊繼續之後，這時會收到一封驗證 Apple ID的電子郵件，需要把郵箱驗證碼填寫上去。',
    tjfkfs: '隨後就會它會自動跳轉到Apple ID的管理頁面（可能會要 加載一會兒）進入到管理頁面後，點擊付款和送貨，並在 接下來的頁面中點擊添加付款方式。',
    mgsfzsc: '到了最關鍵的時刻了，確認付款方式是不是“無”，如果是 “無”就不要動了國家或地區是不是美國或者你想註冊的地 區，其他內容都可以隨便填。但是最好填寫英文，省/市選 擇阿拉斯加，因為這個地區可以免稅，購買App也可以免 稅。具體的個人信息填寫可以通過網站生成：美國身份證生 成',
    gxdqxx: '填寫完成後點擊更新，更新地區信息。',
    zhxx: '1、進入App Store，點擊右上方的頭像，進入到賬戶頁面',
    djwc: '2、滑動該頁面至底部，點擊“退出登錄”即可退出商店ID 再點擊”完成”',
    jrzhdl: '1、再次點擊右上角的頭像，進入賬號登錄頁面',
    zhmmdl: '2、輸入賬號、密碼，點擊“登錄”，進行登錄',
    jydlcg: '3、輸入驗證碼，成功檢驗後，即登錄成功Apple ID',
    jysssd: '交易隨時隨地',
    smewm: '掃描二維碼',
    xiazai: '下載',
    huodong: '活動',
    title1: 'Biking 多元化遊戲',
    title2: '及數字貨幣交易平台',
    open: '在“Biking”App中打開',
    ggzx: '公告中心',
    lscb: '鏈上充幣',
    fbrj: '法幣入金',
    tgaq: '致力於為用戶提供更為安全',
    wdjmzc: '穩定的加密資產衍生品交易服務',
    szhbjy: '數字貨幣交易我們是專業的',
    yxhsjh: '通過電子郵箱/手機號碼註冊',

    appBetaTag: 'BETA版正式上線',
    appHeroTitle: 'App全新升級',
    appHeroSubtitle: '開啟 Biking 交易新航線',
    tryNow: '立即體驗',
    downloadBikingApp: '下載 Biking App',
    roadmapStageMeta: '/{total} {phase}',
    roadmapPhase1: '第一階段',
    roadmapPhase2: '第二階段',
    roadmapPhase3: '第三階段',
    roadmapPhase4: '第四階段',
    roadmapPhase5: '第五階段',
    roadmapVisionTitle: '視覺重構',
    roadmapVisionDesc: '全新設計語言 · 極致交互體驗 · 沉浸式界面',
    roadmapVisionPoint1: '全新設計語言',
    roadmapVisionPoint2: '極致交互體驗',
    roadmapVisionPoint3: '沉浸式界面',
    roadmapEngineTitle: '性能引擎升級',
    roadmapEngineDesc: '底層架構重構 · 毫秒級響應 · 極致穩定性',
    roadmapEnginePoint1: '底層架構重構',
    roadmapEnginePoint2: '毫秒級響應',
    roadmapEnginePoint3: '極致穩定性',
    roadmapBetaTitle: 'Beta 開啟',
    roadmapBetaDesc: '新一代交易系統 · 極速撮合 · 限時體驗',
    roadmapBetaPoint1: '新一代交易系統',
    roadmapBetaPoint2: '極速撮合',
    roadmapBetaPoint3: '限時體驗',
    roadmapGlobalTitle: '平台全面進化',
    roadmapAiTitle: 'AI 交易時代',
    comingSoon: '敬請期待',
    appCopyright: '© 2016-2026 BiKing 版權所有',
    testFlight: 'Test Flight',
    appStore: 'App Store',
    googlePlay: 'Google Play',
    superSign: '超級簽',
    chooseDownload: '選擇下載方式',
    downloadAddr1: '下載地址1',
    downloadAddr2: '下載地址2',
    downloadCancel: '取消',
    apkLocalDownload: '本地下載 APK',
    entryBetaTitle: 'Beta 版本已開放',
    entryBetaSubtitle: '體驗最新功能，搶先嘗鮮',
    entryBetaTitleFull: 'Beta 版本已開放，體驗最新功能，搶先嘗鮮！',
    entryDownloadNow: '立即下載',
    entryTagNew: 'New',
    entryClose: '關閉',
  }
  export {login, download}


// WEBPACK FOOTER //
// ./src/i18n/lang/login/tw.js